import { render } from "./errorPage2.vue?vue&type=template&id=722af84c&scoped=true"
const script = {}

import "./errorPage2.vue?vue&type=style&index=0&id=722af84c&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722af84c"]])

export default __exports__